module.exports = __webpack_public_path__ + "static/media/IMG_9823.d8584c70.jpg";